import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { Toaster } from './components/ui/sonner';
import ScrollToTop from './components/layout/ScrollToTop';

// Pages
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Industries from './pages/Industries';
import IndustryDetail from './pages/IndustryDetail';
import ClientSuccess from './pages/ClientSuccess';
import CaseStudyDetail from './pages/CaseStudyDetail';
import Insights from './pages/Insights';
import PartnerEcosystem from './pages/PartnerEcosystem';
import About from './pages/company/About';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Sitemap from './pages/Sitemap';
import Leadership from './pages/company/leadership';
import Locations from './pages/company/GlobalLocation';
import Awards from './pages/company/Awards';
import Diversity from './pages/company/Diversity';
import InnovationLab from './pages/company/InnovationLab';




// Simple placeholder components for sub-pages
// const Leadership = () => (
//   <div className="min-h-screen py-20">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <h1 className="text-4xl font-bold text-gray-900 mb-8">Leadership Team</h1>
//       <p className="text-xl text-gray-600">Complete leadership team page coming soon.</p>
//     </div>
//   </div>
// );

// const Locations = () => (
//   <div className="min-h-screen py-20">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <h1 className="text-4xl font-bold text-gray-900 mb-8">Global Locations</h1>
//       <p className="text-xl text-gray-600">Global locations page coming soon.</p>
//     </div>
//   </div>
// );

// const Awards = () => (
//   <div className="min-h-screen py-20">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <h1 className="text-4xl font-bold text-gray-900 mb-8">Awards & Recognition</h1>
//       <p className="text-xl text-gray-600">Awards page coming soon.</p>
//     </div>
//   </div>
// );

const ESG = () => (
  <div className="min-h-screen py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">ESG & Sustainability</h1>
      <p className="text-xl text-gray-600">ESG page coming soon.</p>
    </div>
  </div>
);

// const Diversity = () => (
//   <div className="min-h-screen py-20">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <h1 className="text-4xl font-bold text-gray-900 mb-8">Diversity & Inclusion</h1>
//       <p className="text-xl text-gray-600">Diversity & Inclusion page coming soon.</p>
//     </div>
//   </div>
// );

// const InnovationLab = () => (
//   <div className="min-h-screen py-20">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <h1 className="text-4xl font-bold text-gray-900 mb-8">Innovation Lab</h1>
//       <p className="text-xl text-gray-600">Innovation Lab page coming soon.</p>
//     </div>
//   </div>
// );

const InsightDetail = () => (
  <div className="min-h-screen py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Insight Detail</h1>
      <p className="text-xl text-gray-600">Insight detail page coming soon.</p>
    </div>
  </div>
);

const CareerDetail = () => (
  <div className="min-h-screen py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Job Details</h1>
      <p className="text-xl text-gray-600">Job details page coming soon.</p>
    </div>
  </div>
);

const Cookies = () => (
  <div className="min-h-screen py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Cookie Policy</h1>
      <p className="text-xl text-gray-600">Cookie policy page coming soon.</p>
    </div>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* ✅ ADD HERE */}
        <ScrollToTop />
        
        <Routes>
          
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            
            {/* Services */}
            <Route path="services" element={<Services />} />
            <Route path="services/:slug" element={<ServiceDetail />} />
            
            {/* Industries */}
            <Route path="industries" element={<Industries />} />
            <Route path="industries/:slug" element={<IndustryDetail />} />
            
            {/* Client Success */}
            <Route path="client-success" element={<ClientSuccess />} />
            <Route path="client-success/:id" element={<CaseStudyDetail />} />
            
            {/* Insights */}
            <Route path="insights" element={<Insights />} />
            <Route path="insights/:id" element={<InsightDetail />} />
            
            {/* Partner Ecosystem */}
            <Route path="partner-ecosystem" element={<PartnerEcosystem />} />
            
            {/* About */}
            <Route path="about" element={<About />} />
            <Route path="about/leadership" element={<Leadership />} />
            <Route path="about/locations" element={<Locations />} />
            <Route path="about/awards" element={<Awards />} />
            <Route path="about/esg" element={<ESG />} />
            <Route path="about/diversity" element={<Diversity />} />
            <Route path="about/innovation-lab" element={<InnovationLab />} />
            
            {/* Careers */}
            <Route path="careers" element={<Careers />} />
            <Route path="careers/:id" element={<CareerDetail />} />
            
            {/* Contact */}
            <Route path="contact" element={<Contact />} />
            
            {/* Legal */}
            <Route path="privacy" element={<Privacy />} />
            <Route path="terms" element={<Terms />} />
            <Route path="cookies" element={<Cookies />} />
            <Route path="sitemap" element={<Sitemap />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;